import React from 'react';
import './Input.scss';

const Textarea = ({ label, name, value, onChange, placeholder = '', required = false, error = '', className = '', rows = 4 }) => {
    return (
        <div className={`input-group ${className}`}>
            {label && <label htmlFor={name}>{label}{required && <span className="required">*</span>}</label>}
            <textarea
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                className={error ? 'error' : ''}
                rows={rows}
            />
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default Textarea;
